"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(dictionary) {
    return ['FT.DICTDUMP', dictionary];
}
exports.transformArguments = transformArguments;
